'use client';

import { useTranslations } from 'next-intl';
import { ConfirmationDialog } from '../confirmation-dialog/ConfirmationDialog';

export type CredentialDeleteConfirmationDialogProps = {
  credential: { name?: string | null; username: string } | null;
  isDeleting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const CredentialDeleteConfirmationDialog = ({
  credential,
  isDeleting,
  onCancel,
  onConfirm,
}: CredentialDeleteConfirmationDialogProps) => {
  const t = useTranslations('designSystem.credentials.deleteConfirm');

  return (
    <ConfirmationDialog
      isOpen={!!credential}
      onOpenChange={({ open }) => {
        if (!open) {
          onCancel();
        }
      }}
      variant="destructive"
      title={t('title')}
      description={t('description', {
        name: credential?.name || credential?.username || '',
      })}
      confirmText={t('confirm')}
      cancelText={t('cancel')}
      onConfirm={onConfirm}
      loading={isDeleting}
    />
  );
};
